<div class="summary-skeleton">
  <div
    *coaRepeatElement="2"
    class="summary-skeleton__brand-summary-wrapper">
    <coa-brand-summary-skeleton></coa-brand-summary-skeleton>
    <coa-list-element-skeleton
      *coaRepeatElement="3"
      class="summary-skeleton__brand-traffic">
    </coa-list-element-skeleton>
  </div>
</div>
